module.exports = "/assets/dist/images/bodystyles_sedans_sm.png?1edc0d06be45d286aae0e30b8cf75f71";